/**
 * @flow
 * @relayHash fac082322f99fe4b41d9a2278a9bbc02
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type select_front_square_box_by_guest_mutationInput = {|
  squaresInput?: ?squaresInputType,
  clientMutationId?: ?string,
|};
export type squaresInputType = {|
  id?: ?string,
  guest_id: number,
  event_id: number,
  question_id: number,
  answer_row: number,
  answer_col: number,
  assigned_by_admin?: ?boolean,
|};
export type selectFrontSquareBoxByGuestFrontMutationVariables = {|
  input: select_front_square_box_by_guest_mutationInput
|};
export type selectFrontSquareBoxByGuestFrontMutationResponse = {|
  +selectFrontSquareBoxByGuest: ?{|
    +code: ?number,
    +message: ?string,
  |}
|};
export type selectFrontSquareBoxByGuestFrontMutation = {|
  variables: selectFrontSquareBoxByGuestFrontMutationVariables,
  response: selectFrontSquareBoxByGuestFrontMutationResponse,
|};
*/


/*
mutation selectFrontSquareBoxByGuestFrontMutation(
  $input: select_front_square_box_by_guest_mutationInput!
) {
  selectFrontSquareBoxByGuest(input: $input) {
    code
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "select_front_square_box_by_guest_mutationInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "selectFrontSquareBoxByGuest",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "select_front_square_box_by_guest_mutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "selectFrontSquareBoxByGuestFrontMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "selectFrontSquareBoxByGuestFrontMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "selectFrontSquareBoxByGuestFrontMutation",
    "id": null,
    "text": "mutation selectFrontSquareBoxByGuestFrontMutation(\n  $input: select_front_square_box_by_guest_mutationInput!\n) {\n  selectFrontSquareBoxByGuest(input: $input) {\n    code\n    message\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41f931e75bfb2672312509f476b79172';
module.exports = node;
